import ProductOrderAttachmentType from "./ProductOrderAttachmentType";

class ProductOrderAttachmentResponse {
    public id: string;
    public productOrderId: string;
    public image: string;
    public type: ProductOrderAttachmentType;
    public description: string;
    public userId: string;
    public createdAt: number;
    
    constructor(
        id: string,
        productOrderId: string,
        image: string,
        type: ProductOrderAttachmentType,
        description: string,
        userId: string,
        createdAt: number) {
        this.id = id;
        this.productOrderId = productOrderId;
        this.image = image;
        this.type = type;
        this.description = description;
        this.userId = userId;
        this.createdAt = createdAt;
    }

}

export default ProductOrderAttachmentResponse;